import { createContext, useState, useMemo } from "react";

export const InvestTheRestContext = createContext();

export const InvestTheRestProvider = ({ children }) => {
  const [keepYesCheckboxChecked, setKeepYesCheckboxChecked] = useState(false);
  const [flexiValueInvestRest, setFlexiValueInvestRest] = useState(0);
  const [safetyValueInvestRest, setSafetyValueInvestRest] = useState(0);
  const [legacyValueInvestRest, setLegacyValueInvestRest] = useState(0);

  const resetInvestTheRestValues = () => {
    setKeepYesCheckboxChecked(false);
    setFlexiValueInvestRest(0);
    setSafetyValueInvestRest(0);
    setLegacyValueInvestRest(0);
  };

  const value = useMemo(
    () => ({
      keepYesCheckboxChecked,
      setKeepYesCheckboxChecked,
      flexiValueInvestRest,
      setFlexiValueInvestRest,
      safetyValueInvestRest,
      setSafetyValueInvestRest,
      legacyValueInvestRest,
      setLegacyValueInvestRest,
      resetInvestTheRestValues,
    }),
    [
      keepYesCheckboxChecked,
      flexiValueInvestRest,
      safetyValueInvestRest,
      legacyValueInvestRest,
    ],
  );

  return (
    <InvestTheRestContext.Provider value={value}>
      {children}
    </InvestTheRestContext.Provider>
  );
};
